module.exports = __webpack_public_path__ + "static/media/motorcyk-motorcycle-community.2b81bc6e.jpg";